/*******************************************************************************
 * Copyright     : Copyright (c)  2024 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc.No part may be reproduced or transmitted in any form by any
 *                 means or for anypurpose without the express written permission of Honeywell. *
 *******************************************************************************/
import React from "react";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { RootState } from "../store";

import { ROUTE_PATH } from "./constants";

import { setDeviceListUpdated } from "../actions";

export const useNavigateToLandingPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { isStandalone } = useSelector((state: RootState) => state.global);

  const navigateToLandingPage = () => {
    if (isStandalone === 'standAlone') {
      navigate(ROUTE_PATH.deviceslist);
    } else {
      navigate(ROUTE_PATH.landingPage);
      dispatch(setDeviceListUpdated({ deviceListUpdated: true }));
    }
  };

  return { navigateToLandingPage };
};